import { createSlice } from "@reduxjs/toolkit";

export const get_soil_type = createSlice({
  name: "soil_type",
  initialState: {
    value: { status: false, data: [] },
  },
  reducers: {
    updateStoreSoilType: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateStoreSoilType } = get_soil_type.actions;

export default get_soil_type.reducer;
